import { render, staticRenderFns } from "./listConstruction.vue?vue&type=template&id=5b0a2c5d"
import script from "./listConstruction.vue?vue&type=script&lang=js"
export * from "./listConstruction.vue?vue&type=script&lang=js"
import style0 from "./listConstruction.vue?vue&type=style&index=0&id=5b0a2c5d&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports